import { UuidT } from "../generated/front-end/uuid";
import { uuidToString } from "../../utils/uuid";

/**
 * Formats a FlatBuffer UuidT as a hyphenated UUID string.
 * Also accepts plain string UUIDs (from JSON/legacy data) for compatibility.
 * Returns empty string for null/undefined (unlike uuidToString which returns ZERO_UUID).
 */
export default function formatUuidT(uuid: UuidT | string | number | null | undefined): string {
  if (typeof uuid === "number") return String(uuid);
  if (typeof uuid === "string") return uuid;
  if (!uuid?.value) return "";
  return uuidToString(uuid);
}
